import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from 'iovisit-ferraraterraeacqua/components/Blocks/EventProgram/Sidebar';
import Body from 'iovisit-ferraraterraeacqua/components/Blocks/EventProgram/Body';

const Edit = (props) => {
  return (
    <div className="block event-program">
      <Body {...props} isEditMode={true} />
      <SidebarPortal selected={props.selected}>
        <Sidebar {...props} />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
